import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging from "biz-ts/src/api/Paging";
import {DtaskPqForm} from "@/form/DeviceTaskForm";
import DeviceTask from "@/model/DeviceTask";

@Singleton
export default abstract class DeviceTaskApi {
    abstract paging(form: DtaskPqForm): Promise<Paging<DeviceTask>>
}

class DeviceTaskApiImpl extends BaseApi implements DeviceTaskApi {

    protected urlPrefix = 'device/task'

    paging(form: DtaskPqForm): Promise<Paging<DeviceTask>> {
        return this.axios.get('paging', {params: form})
    }
}

Container.bind(DeviceTaskApi).to(DeviceTaskApiImpl)
